import bounceApiClient from 'legacy/common/utils/bounceApiClient';

export interface VerifyMembershipCodeResponse {
  type: 'discountCode';
}

/**
 * Verifies a discount code for an organization membership checkout
 */
export async function verifyMembershipCode(
  organizationId: string,
  code: string
): Promise<VerifyMembershipCodeResponse> {
  const { data } = await bounceApiClient.get(
    `/checkoutSessions/organizations/${organizationId}/verify-code`,
    {
      params: { code }
    }
  );

  return data;
}
